import type { ReactNode } from 'react';

/**
 * The ambient purple/blue wash the whole app sits on, matching the existing
 * dashboard. Static CSS, not a 3D scene: it is decorative, it must not cost a
 * driver on mobile anything, and it must not intercept pointer events.
 */
export function AppBackdrop({ children }: { children: ReactNode }) {
  return (
    <div className="bg-background relative flex min-h-dvh flex-col">
      <div className="app-backdrop pointer-events-none absolute inset-0 z-0" aria-hidden />
      <div className="relative z-10 flex min-h-dvh flex-1 flex-col">{children}</div>
    </div>
  );
}
